// extracted by mini-css-extract-plugin
export default {"note":"cogiXJjNqTHalnuofW8g","noteIcon":"l7DQeWfvm124zKtH6CJ4","noteContent":"QTnxfx4rjCQa7da22pwA"};